// getCurr
function getCurr(current_date_full) {
    if (current_date_full) {
        // curr month
        let serverTime = new Date(current_date_full);
        // end
        return new Date(Date.UTC(serverTime.getFullYear(), serverTime.getMonth(), 1)).toLocaleDateString('en-CA', { timeZone: 'UTC' });
    }
}

// getPrev
function getPrev(current_date_full) {
    if (current_date_full) {
        // prev month
        let previousMonth = new Date(new Date(current_date_full).setMonth(new Date(current_date_full).getMonth() - 1));
        // end
        return new Date(Date.UTC(previousMonth.getFullYear(), previousMonth.getMonth(), 1)).toLocaleDateString('en-CA', { timeZone: 'UTC' });
    }
}


// minDate
function getMinDate(serverDate, searchPeriod, enrollee) {
    if (serverDate && searchPeriod && enrollee) {
        // activate date
        const searchStartDate = new Date(searchPeriod); // Search start date (1st day)
        const enrolleeStartDate = new Date(enrollee.new_start_date); // enrollee new_start_date

        if (enrolleeStartDate.getTime() > searchStartDate.getTime()) {
            return enrolleeStartDate;
        } else {
            return searchStartDate;
        }

    }
}

// maxDate
function getMaxDate(serverDate, searchPeriod, enrollee) {
    if (serverDate && searchPeriod && enrollee) {
        // activate date
        const currentDate = new Date(serverDate); // Today's date
        const searchStartDate = new Date(searchPeriod); // Search date (1st day)
        const searchEndDate = new Date(searchStartDate.getFullYear(), searchStartDate.getMonth() + 1, 0); // Search end date (last day)
        const enrolleeEndDate = new Date(enrollee.new_end_date); // enrollee new_end_date
        const validatedEndDate = searchEndDate.getTime() < currentDate.getTime() ? searchEndDate : currentDate; // validated end date

        if (enrolleeEndDate.getTime() < validatedEndDate.getTime()) {
            return enrolleeEndDate;
        } else {
            return validatedEndDate;
        }

    }
}


export {
    getCurr,
    getPrev,
    getMinDate,
    getMaxDate,
}